import { Box, Typography, Button, Container } from "@mui/material";
import { Link } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFound = () => {
  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="80vh"
        textAlign="center"
      >
        <ErrorOutlineIcon sx={{ fontSize: 70, color: "#043841" }} />
        <Typography variant="h1" fontWeight="bold" color="#043841" mt={1} style={{ fontSize: "70px" }} >
          404
        </Typography>
        <Typography variant="h5" mt={1}>
        עמוד לא נמצא
        </Typography>
        <Typography variant="body1" color="textSecondary" mt={2}>
        חיפשנו בכל מקום את הדף הזה.
          <br />
          האם אתה בטוח שכתובת האתר נכונה?
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          sx={{ mt: 3, px: 4,background: "#043841", color: "#ffffff !important" }}
          className="btn"
        >
          חזור הביתה
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
